/* AS3 cart drawer: subscription switch, routine upsell, header count sync */
(function () {
  if (window.__as3cd) return;
  window.__as3cd = true;

  var SECTIONS = ['cart-drawer', 'cart-icon-bubble'];

  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function drawer() { return document.querySelector('cart-drawer'); }

  function money(cents) {
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') return Shopify.formatMoney(cents, window.theme && theme.moneyFormat);
    } catch (e) {}
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  function inner(html, selector) {
    var el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return el ? el.innerHTML : null;
  }

  function applySections(state) {
    var d = drawer();
    if (!d || !state || !state.sections) return;
    var di = d.querySelector('.drawer__inner');
    var h = state.sections['cart-drawer'] && inner(state.sections['cart-drawer'], '.drawer__inner');
    if (di && h !== null) di.innerHTML = h;
    var bubble = document.getElementById('cart-icon-bubble');
    var b = state.sections['cart-icon-bubble'] && inner(state.sections['cart-icon-bubble'], '.shopify-section');
    if (bubble && b !== null) bubble.innerHTML = b;
    d.classList.toggle('is-empty', state.item_count === 0);
    try {
      if (typeof publish === 'function' && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: state });
    } catch (e) {}
  }

  function setBusy(on) {
    var d = drawer();
    if (d) d.classList.toggle('as3cd-busy', !!on);
  }

  function changeLine(line, qty, plan) {
    setBusy(true);
    var body = { line: Number(line), quantity: Number(qty), selling_plan: plan ? Number(plan) : null, sections: SECTIONS, sections_url: window.location.pathname };
    return fetch(root() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (state) { if (!state.errors) applySections(state); })
      .catch(function (e) { console.error(e); })
      .finally(function () { setBusy(false); });
  }

  document.addEventListener('click', function (e) {
    var sw = e.target.closest && e.target.closest('[data-as3cd-subscribe]');
    if (sw) {
      e.preventDefault();
      sw.setAttribute('aria-pressed', 'true');
      sw.classList.add('is-on');
      changeLine(sw.dataset.line, sw.dataset.qty, sw.dataset.plan);
    }
  });

  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-as3cd-plan]');
    if (!sel) return;
    e.stopPropagation();
    changeLine(sel.dataset.line, sel.dataset.qty, sel.value || null);
  }, true);

  /* Header count: cart.js onCartUpdate swaps cart-drawer-items only, so resync the badge */
  function syncCount() {
    var d = drawer();
    if (!d) return;
    var items = d.querySelector('cart-drawer-items');
    var badge = d.querySelector('[data-as3cd-count]');
    if (items && badge && items.dataset.count && badge.textContent !== items.dataset.count) badge.textContent = items.dataset.count;
  }
  function watch() {
    var d = drawer();
    if (!d) return;
    new MutationObserver(syncCount).observe(d, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();

  /* Complete your routine */
  var cache = {};
  function strip(t) { return String(t || '').replace(/^Absolut Skin\s*[|\-–]\s*/i, ''); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function img(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function fetchRecs(pid) {
    if (cache[pid]) return Promise.resolve(cache[pid]);
    var base = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'recommendations/products.json?limit=10&product_id=' + pid;
    function get(intent) {
      return fetch(base + '&intent=' + intent).then(function (r) { return r.ok ? r.json() : { products: [] }; }).then(function (j) { return j.products || []; }).catch(function () { return []; });
    }
    return get('complementary').then(function (a) {
      return get('related').then(function (b) {
        var seen = {}, out = [];
        a.concat(b).forEach(function (p) { if (!seen[p.id]) { seen[p.id] = 1; out.push(p); } });
        cache[pid] = out;
        return out;
      });
    });
  }

  class As3CartUpsell extends HTMLElement {
    connectedCallback() {
      var self = this;
      var pid = this.dataset.productId;
      if (!pid) return;
      var ex = (this.dataset.exclude || '').split(',').filter(Boolean);
      fetchRecs(pid).then(function (list) {
        var picks = list.filter(function (p) {
          return p.available && ex.indexOf(String(p.id)) === -1 && !/bundle|trio|kit|set\b/i.test(p.title);
        }).slice(0, 6);
        if (!picks.length) return;
        var track = self.querySelector('[data-track]');
        track.innerHTML = picks.map(function (p) {
          var v = (p.variants || []).filter(function (x) { return x.available; })[0] || p.variants[0];
          var src = p.featured_image || (p.images && p.images[0]) || '';
          var cmp = v.compare_at_price && v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s>' : '';
          return '<div class="as3cd-u">' +
            '<a class="as3cd-u__p" href="' + esc(p.url) + '">' +
              (src ? '<img src="' + esc(img(src, 140)) + '" alt="" width="46" height="46" loading="lazy">' : '<span class="as3cd-u__ph"></span>') +
              '<span><b>' + esc(strip(p.title)) + '</b><small>' + cmp + money(v.price) + '</small></span>' +
            '</a>' +
            '<button type="button" class="as3cd-u__add" data-variant="' + v.id + '">+ Add</button>' +
          '</div>';
        }).join('');
        self.hidden = false;
        self.querySelectorAll('[data-dir]').forEach(function (b) {
          b.addEventListener('click', function () {
            var card = track.querySelector('.as3cd-u');
            var step = card ? card.getBoundingClientRect().width + 10 : 200;
            track.scrollBy({ left: step * Number(b.dataset.dir), behavior: 'smooth' });
          });
        });
        self.querySelector('.as3cd-up__nav').hidden = picks.length < 3;
        track.addEventListener('click', function (e) {
          var btn = e.target.closest('.as3cd-u__add');
          if (!btn || btn.disabled) return;
          btn.disabled = true;
          btn.textContent = 'Adding…';
          setBusy(true);
          fetch(root() + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(btn.dataset.variant), quantity: 1 }], sections: SECTIONS, sections_url: window.location.pathname })
          })
            .then(function (r) { return r.json(); })
            .then(function (state) {
              if (state.status || state.errors) { btn.disabled = false; btn.textContent = '+ Add'; return; }
              var d = drawer();
              if (d && typeof d.renderContents === 'function') {
                d.renderContents({ id: btn.dataset.variant, sections: state.sections });
              }
              try {
                if (typeof publish === 'function' && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', productVariantId: btn.dataset.variant });
              } catch (e) {}
            })
            .catch(function () { btn.disabled = false; btn.textContent = '+ Add'; })
            .finally(function () { setBusy(false); });
        });
      });
    }
  }
  if (!customElements.get('as3-cart-upsell')) customElements.define('as3-cart-upsell', As3CartUpsell);
})();
